import { AppState } from 'src';
import { ContractResaleComponentProperties, ContractResaleComponent } from './contract-resale.component';
import { Dispatch, connect } from 'react-redux';
import { getContractResaleData, setResaleLoading } from 'src/contract/contract-resale.actions';
import { doAsync } from '@common/components/common.actions';

interface ContractResaleProperties {
  readonly saveCallback: () => void;
  readonly buttonRef: (button: HTMLButtonElement) => void;
  readonly isModal: boolean;
  readonly isLoadingResale: boolean;
}

function mapStateToProps(
  state: AppState,
  ownProps: ContractResaleProperties
): Partial<ContractResaleComponentProperties> {
  return {
    contractResaleModalVM: state.contract.contractResaleModalVM,
    saveCallback: ownProps.saveCallback,
    buttonRef: ownProps.buttonRef,
    isModal: ownProps.isModal,
    isLoadingResale: state.contract.isLoadingResale === undefined ? true : state.contract.isLoadingResale
  };
}
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: ContractResaleProperties
): Partial<ContractResaleComponentProperties> {
  return {
    getContractResaleData: (id: number, date: Date) => {
      dispatch(doAsync(setResaleLoading(true))).then(() => {
        dispatch(getContractResaleData(id, date)).then(() => {
          dispatch(setResaleLoading(false));
        });
      });
    }
  };
}

export const ContractResale = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractResaleComponent);



// WEBPACK FOOTER //
// ./src/contract/_components/contract-resale/contract-resale.container.ts